export default "__VITE_ASSET__8b0040e8__"